import "focus-visible/dist/focus-visible";
import { Amplify } from "aws-amplify";
import outputs from "./amplify_outputs.json";
import { hasConsent, startAnalytics, trackPageView } from "./src/lib/analytics";

Amplify.configure(outputs);

export function onRouteUpdate() {
  window.locations = window.locations || [document.referrer];
  window.locations.push(window.location.href);
  window.previousPath = window.locations[window.locations.length - 2];

  // Fires on the initial render too, so this covers the landing page.
  if (hasConsent()) {
    startAnalytics();
    trackPageView();
  }
}

export function wrapPageElement({ element }) {
  const getLayout = element.type.getLayout || ((page) => page);
  return getLayout(element);
}
